// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__zbZi7","header":"ReportDetails_header__2jzhu","title":"ReportDetails_title__p3zgc","left":"ReportDetails_left__21jtL"};